import { render, staticRenderFns } from "./openclass-sharePage.vue?vue&type=template&id=4fba3c9e"
import script from "./openclass-sharePage.vue?vue&type=script&lang=js"
export * from "./openclass-sharePage.vue?vue&type=script&lang=js"
import style0 from "./openclass-sharePage.vue?vue&type=style&index=0&id=4fba3c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports